import { FILTERS_TYPE, SET_FILTERS } from '../types/products';

export const setFilters = (filters: FILTERS_TYPE): { type: string; filters: FILTERS_TYPE } => {
  return {
    type: SET_FILTERS,
    filters,
  };
};
